export default {
  setMicrophone(value) {
    this.microphone = !!value;
  },

  setCamera(value) {
    this.camera = !!value;
  },

  setIsRemoteParticipantOffCamera(value) {
    this.isRemoteParticipantOffCamera = !!value;
  },

  setIsRemoteParticipantOffAudio(value) {
    this.isRemoteParticipantOffAudio = !!value;
  },

  setIsRemoteParticipantConnected(value) {
    this.isRemoteParticipantConnected = !!value;
  },

  setStateZoomToken(value) {
    this.stateZoomToken = value ?? null;
  },

  setStateZoomVideoClient(value) {
    this.stateZoomVideoClient = value ?? null;
  },

  setStateActiveZoomStream(value) {
    this.stateActiveZoomStream = value ?? null;
  },

  resetVideoSession() {
    this.microphone = true;
    this.camera = true;
    this.isRemoteParticipantOffCamera = false;
    this.isRemoteParticipantOffAudio = false;
    this.isRemoteParticipantConnected = false;

    this.stateZoomToken = null;
    this.stateZoomVideoClient = null;
    this.stateActiveZoomStream = null;
  },
};
